import {useLocation} from 'react-router-dom';

const useIsPage = (pagePathName) => {
    const {pathname} = useLocation();

    return pathname === pagePathName;
};

export default useIsPage;
